// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
  },
  // SETUP
  setup: {
    root: '/setup',
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    settings: `${ROOTS.DASHBOARD}/settings/:tab?`,
    crm: {
      root: `${ROOTS.DASHBOARD}/CRM`,
      cliente: `${ROOTS.DASHBOARD}/CRM/Cliente`,
      proveedor: `${ROOTS.DASHBOARD}/CRM/Proveedor`,
      contacto: `${ROOTS.DASHBOARD}/CRM/Contacto`,
      parametros: `${ROOTS.DASHBOARD}/CRM/Parametros`,
    },
    ventas: {
      root: `${ROOTS.DASHBOARD}/Ventas`,

      cotizacion: `${ROOTS.DASHBOARD}/Ventas/Cotizacion`,

      cliente: `${ROOTS.DASHBOARD}/Ventas/Cliente`,

      parametros: `${ROOTS.DASHBOARD}/Ventas/Parametros`,
    },
    produccion: {
      root: `${ROOTS.DASHBOARD}/Produccion`,
      orden: `${ROOTS.DASHBOARD}/Produccion/Orden`,
      proyecto: `${ROOTS.DASHBOARD}/Produccion/Proyecto`,
      parametros: `${ROOTS.DASHBOARD}/Produccion/Parametros`,
      produccion: `${ROOTS.DASHBOARD}/Produccion/Produccion`,
    },

    compras: {
      root: `${ROOTS.DASHBOARD}/Compras`,

      compras: `${ROOTS.DASHBOARD}/Compras/Compras`,

      certificado: `${ROOTS.DASHBOARD}/Compras/Certificado`,

      proveedor: `${ROOTS.DASHBOARD}/Compras/Proveedor`,

      insumo: `${ROOTS.DASHBOARD}/Compras/Insumo`,

      insumoProveedorStock: `${ROOTS.DASHBOARD}/Compras/InsumoProveedorStock`,

      insumoProveedor: `${ROOTS.DASHBOARD}/Compras/InsumoProveedor`,
      parametros: `${ROOTS.DASHBOARD}/Compras/Parametros`,
    },

    facturacion: {
      root: `${ROOTS.DASHBOARD}/Facturacion`,

      facturacion: `${ROOTS.DASHBOARD}/Facturacion/Facturacion`,

      remito: `${ROOTS.DASHBOARD}/Facturacion/Remito`,

      recibo: `${ROOTS.DASHBOARD}/Facturacion/Recibo`,

      // moneda: `${ROOTS.DASHBOARD}/Facturacion/Moneda`,

      // tipoComprobante: `${ROOTS.DASHBOARD}/Facturacion/TipoComprobante`,

      // puntoDeVenta: `${ROOTS.DASHBOARD}/Facturacion/PuntoDeVenta`,

      // sistemaPtoVenta: `${ROOTS.DASHBOARD}/Facturacion/SistemaPtoVenta`,

      // condicionIva: `${ROOTS.DASHBOARD}/Facturacion/CondicionIva`,

      // actividad: `${ROOTS.DASHBOARD}/Facturacion/Actividad`,

      parametros: `${ROOTS.DASHBOARD}/Facturacion/Parametros`,
    },

    productos: {
      root: `${ROOTS.DASHBOARD}/Productos`,

      matrizProducto: `${ROOTS.DASHBOARD}/Productos/MatrizProducto`,

      producto: `${ROOTS.DASHBOARD}/Productos/Producto`,

      tipoProducto: `${ROOTS.DASHBOARD}/Productos/TipoProducto`,

      matriz: `${ROOTS.DASHBOARD}/Productos/Matriz`,

      // compuesto: `${ROOTS.DASHBOARD}/Productos/Compuesto`,

      formulacionCompuesto: `${ROOTS.DASHBOARD}/Productos/FormulacionCompuesto`,

      productoInsumos: `${ROOTS.DASHBOARD}/Productos/ProductoInsumos`,

      parametros: `${ROOTS.DASHBOARD}/Productos/Parametros`,
      productoStock: `${ROOTS.DASHBOARD}/Productos/ProductoStock`,
    },

    mensajeCuerpo: `${ROOTS.DASHBOARD}/MensajeCuerpo`,

    mensaje: `${ROOTS.DASHBOARD}/Mensaje`,

    kPIs: `${ROOTS.DASHBOARD}/KPIs`,
  },
};
